// extracted by mini-css-extract-plugin
export default {"header":"Header_header__wRsht","title":"Header_title__kwx0G","description":"Header_description__Y8Z1t","profile":"Header_profile__SF7CK","notification":"Header_notification__ynz5Y"};